import { Box } from "@chakra-ui/react";
import { MapRef } from "react-map-gl/maplibre";

import type {
  CompositeLegendEntry,
  FillCompositeLegendEntry,
  LineCompositeLegendEntry,
} from "../../../types/legend-types";

import { SimpleSwatch } from "./simple-swatch";
import { SpriteSwatch } from "./sprite-swatch";

interface CompositeSwatch {
  entry: CompositeLegendEntry;
  map: MapRef | undefined;
}

export function CompositeSwatch({ entry, map }: CompositeSwatch) {
  if (entry.kind === "composite-line") {
    return <LineCompositeSwatch entry={entry} map={map} />;
  }
  return <FillCompositeSwatch entry={entry} map={map} />;
}

function FillCompositeSwatch({
  entry,
  map,
}: {
  entry: FillCompositeLegendEntry;
  map: MapRef | undefined;
}) {
  const fillColor = entry.fillColor ?? "transparent";

  let borderStyle: "solid" | "dashed" | "dotted" = "solid";
  if (entry.outlineDasharray) {
    borderStyle = entry.outlineDasharray[0] <= 2 ? "dotted" : "dashed";
  }

  return (
    <>
      {entry.pointIconName ? (
        <Box position="absolute">
          <SpriteSwatch iconName={entry.pointIconName} map={map} />
        </Box>
      ) : null}

      {entry.patternIconName && (
        <Box position="absolute">
          <SpriteSwatch isPattern iconName={entry.patternIconName} map={map} />
        </Box>
      )}

      <SimpleSwatch
        swatchType="fill"
        color={fillColor}
        borderColor={entry.outlineColor}
        borderWidth={entry.outlineWidth}
        borderStyle={entry.outlineColor ? borderStyle : undefined}
        fillOutlineColor={entry.fillOutlineColor}
      />
    </>
  );
}

function LineCompositeSwatch({
  entry,
  map,
}: {
  entry: LineCompositeLegendEntry;
  map: MapRef | undefined;
}) {
  return (
    <>
      <SimpleSwatch color={entry.lineColor} swatchType="line" />

      {entry.pointIconName ? (
        <Box position="absolute">
          <SpriteSwatch iconName={entry.pointIconName} map={map} />
        </Box>
      ) : null}
    </>
  );
}
